angular
    .module("topline.modules")
    .component("forecastPartial", { bindings: { riskOptions: "<" }, template: require("./forecast.html") });
